// Collection-only presentation: retained record readers keep their palette/geometry.
import { T } from "../../app/tokens.js";
import { CAPACITY_CELL } from "./capacityStyles.js";

export const GRID_GAP = 3;
export const GRID_RADIUS = 4;
export const GRID_SIZE = { standard: 20, compact: 14 };
export const GRID_OPEN_BG = `color-mix(in srgb, ${T.blueSoft} 35%, ${T.card})`;
export const GRID_CELL = Object.fromEntries(Object.entries(CAPACITY_CELL).map(([status, style]) => [
  status,
  { ...style },
]));
export const FORECAST_FADE_LABEL = "faded = beyond 24-month forecast confidence";
